var map = {
	"./decidim/avatar-multiuser.png": 35910,
	"./decidim/brands/facebook.svg": 25616,
	"./decidim/brands/google.svg": 51561,
	"./decidim/brands/twitter-x.svg": 86178,
	"./decidim/cc-badge.png": 76280,
	"./decidim/decidim-logo.svg": 72580,
	"./decidim/default-avatar.svg": 60,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 98152,
	"./decidim/icons.svg": 65207,
	"./decidim/pattern.png": 47608,
	"./decidim/placeholder-card-g.svg": 98045,
	"./decidim/placeholder-card-l.svg": 88438,
	"./decidim/placeholder.jpg": 78165,
	"./decidim/remixicon.symbol.svg": 76793,
	"./decidim/vendor/social-share-button/douban.svg": 63064,
	"./decidim/vendor/social-share-button/email.svg": 35733,
	"./decidim/vendor/social-share-button/facebook.svg": 77739,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 9317,
	"./decidim/vendor/social-share-button/hacker_news.svg": 54437,
	"./decidim/vendor/social-share-button/linkedin.svg": 84589,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 22718,
	"./decidim/vendor/social-share-button/pinterest.svg": 46059,
	"./decidim/vendor/social-share-button/reddit.svg": 44927,
	"./decidim/vendor/social-share-button/telegram.svg": 17266,
	"./decidim/vendor/social-share-button/tumblr.svg": 77265,
	"./decidim/vendor/social-share-button/twitter.svg": 16356,
	"./decidim/vendor/social-share-button/vkontakte.svg": 10714,
	"./decidim/vendor/social-share-button/wechat.svg": 60421,
	"./decidim/vendor/social-share-button/whatsapp.svg": 12949,
	"./decidim/vendor/social-share-button/x.svg": 57237,
	"./decidim/vendor/social-share-button/xing.svg": 94091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46347;